import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useTheme } from "@mui/styles";
import { AccentInfo } from "../../StyledComponents";
import { dropdownStylesThin, dropdownMenuProps } from "../../componentThemes";

const PaymentScheduleDropdown = ({ value, handleChange, items, disabled }) => {
  const theme = useTheme()
  const dropdown = dropdownStylesThin(theme)

  return (
    <FormControl className={dropdown.formControl} style={{width: "100%"}}>
      <Select
        disabled={disabled}
        value={value}
        onChange={handleChange}
        MenuProps={dropdownMenuProps}
        classes={{
          select: dropdown.select,
          icon: dropdown.selectIcon
        }}
      >
        {items.length > 0 ?
          items.map((tag) => (
            <MenuItem
              key={tag.apiMapping}
              disabled={value === tag.apiMapping}
              value={tag.apiMapping}
            >
              {tag.label}
            </MenuItem>
          ))
        :
          <MenuItem disabled>
            <AccentInfo>
              no schedules available
            </AccentInfo>
          </MenuItem>
        }
      </Select>
    </FormControl>
  )
}

export default PaymentScheduleDropdown
